import styled from 'styled-components';

export const ShellOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
`;

export const ShellContainer = styled.div`
  width: 100%;
  /* The requested width is the FLOOR on large screens: 30vw lets the dialog
     keep pace with the rest of the page at 4K, and min() keeps it on screen. */
  max-width: min(
    calc(100vw - 32px),
    max(${({ $maxWidth }) => $maxWidth ?? 600}px, 30vw)
  );
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
  background: #fff;

  & > *:not(:first-child) {
    overflow-y: auto;
    overflow-x: hidden;
    overscroll-behavior: contain;
  }

  /* MUI controls render at a fixed pixel size and ignore the scaling above. */
  @media only screen and (min-width: 1700px) {
    .MuiCheckbox-root .MuiSvgIcon-root { font-size: 1.9rem; }
    .MuiSwitch-root { transform: scale(1.2); }
  }

  @media only screen and (min-width: 2100px) {
    .MuiCheckbox-root .MuiSvgIcon-root { font-size: 2.2rem; }
    .MuiSwitch-root { transform: scale(1.35); }
  }

  @media only screen and (min-width: 3000px) {
    .MuiCheckbox-root .MuiSvgIcon-root { font-size: 3.4rem; }
    .MuiSwitch-root { transform: scale(1.9); }
  }
`;

export const ShellHeader = styled.div`
  background: linear-gradient(180deg, #012d4e 0%, #004c7d 100%);
  padding: clamp(16px, 1vw, 38px) clamp(20px, 1.25vw, 48px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

export const ShellTitle = styled.div`
  font-family: 'Saira Semi Condensed', sans-serif;
  font-weight: 800;
  font-size: clamp(20px, 1.25vw, 48px);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #fff;
`;

export const ShellFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  padding: 12px 20px;
  border-top: 1px solid #e5e7eb;
  flex-shrink: 0;
`;

export const ShellFooterGhostBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 6px 4px;
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: clamp(14px, 0.88vw, 34px);
  font-weight: 600;
  color: #004ea3;
  cursor: pointer;
  &:hover { color: #003580; }
`;

export const ShellFooterBtn = styled.button`
  padding: clamp(8px, 0.5vw, 19px) clamp(22px, 1.4vw, 53px);
  border-radius: 8px;
  font-family: 'Saira Semi Condensed', sans-serif;
  font-size: clamp(14px, 0.88vw, 34px);
  font-weight: 700;
  cursor: pointer;
  border: none;
  background: #004ea3;
  color: #fff;
  &:hover { background: #003580; }
`;

export const ShellCloseBtn = styled.button`
  background: none;
  border: none;
  color: #fff;

  svg {
    width: clamp(20px, 1.25vw, 48px);
    height: clamp(20px, 1.25vw, 48px);
  }
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  opacity: 0.85;
  flex-shrink: 0;

  &:hover { opacity: 1; }
`;
